import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type SsoEnablementStatusSerializer = {
  emailDomain: string;
  ssoEnabled: boolean;
};

export type PostSsoEnablementStatusPayloadType = (
  Pick<SsoEnablementStatusSerializer, 'emailDomain'>
);
export type PostSsoEnablementStatusResponseType = (
  Pick<SsoEnablementStatusSerializer, 'ssoEnabled'>
);

export const apiCheckSsoEnablementStatus = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostSsoEnablementStatusPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.ssoEnablementStatus(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
